import { v4 as uuid } from 'uuid'
import type { I18nTranslate } from '@lib/types/common'
import type {
  CollectionFile,
  CollectionPage,
  CollectionPlayer,
  CollectionPlayerV2,
} from '@collection-player/types/collection-player.type'

export const getDefaultNewGroupName = (t: I18nTranslate) => t('canvasUI.collectionSelector.defaultNewGroupName')
export const getDefaultGroupName = (t: I18nTranslate) => t('canvasUI.collectionSelector.defaultGroupName')
export const getDefaultCollectionName = (t: I18nTranslate) => t('canvasUI.collectionSelector.defaultCollectionName')

export const generateNewEmptyGroup = (t: I18nTranslate) => ({
  id: uuid(),
  name: getDefaultNewGroupName(t),
  slides: [],
})

export const generateNewCollection = (t: I18nTranslate) => ({
  name: t('canvasUI.collectionSelector.defaultNewCollectionName'),
  groups: [generateNewEmptyGroup(t)],
})

export const generateNewCollectionSlide = (payload: Pick<CollectionPage, 'file' | 'slide'>): CollectionPage => ({
  ...payload,
  id: uuid(),
  type: 'slide',
})

export const generateNewCollectionFile = (file: CollectionFile['file']): CollectionFile => ({
  id: uuid(),
  type: 'file',
  file,
})

export const getUniqueFilesCount = (data: CollectionPlayer | CollectionPlayerV2) => {
  const fileIds = data.groups.flatMap((group) =>
    group.slides
      .map((slide: any) => {
        // Handle both V1 format (slide.file.id) and V2 format (slide.file_id)
        if (slide.file?.id) {
          return slide.file.id
        } else if (slide.file_id) {
          return slide.file_id
        }
        return null
      })
      .filter(Boolean),
  )
  return new Set(fileIds).size
}

export const getGroupsCount = (data: CollectionPlayer | CollectionPlayerV2) => data.groups.length
export const getSlidesCount = (data: CollectionPlayer | CollectionPlayerV2) =>
  data.groups.reduce((acc, group) => acc + group.slides.length, 0)
